
import {values} from '@/ft-vue-core'
import moment from 'moment'

const {daysLower} = values

export default {
  data: function () {
    return {
      guestTypes: [],
      memberGroups: [],
      memberTypes: [],
      mealPeriods: [],
      musicalStyles: [],
      dressCodes: [],
      allMealPeriods: [],
      blockers: [],
      events: [],
      event: {}, // This wont be reactive in some cases.  Re-think doing it this way.
      locations: [],
      eventToLocations: [],
      reservationStates: [],
      occasions: [],
      cancellationReasons: [],
      confirmationStatuses: [],
      tableConfigurations: [],
      seatingTimes: [],
      membershipTypes: [],
      availableMealPeriodDates: [],
      tableNumberUsage: [],
      memberRestrictions: [],
      itemsHaveIssue: false
    }
  },
  computed: {
    memberRestrictionsMap () {
      return this.memberRestrictions.reduce((a, r) => {a[r.id] = r; return a}, {})
    }
  },
  methods: {
    onSubmitCancelled (ftresponse) {
      // Submit was cancelled for some reason
      // Make sure some things are up-to-date
      const commands = [...this.tableConfigurationsCommand()]
      if (commands.length) {
        this.$ftAPI().get(this.addResourceErrorHandler(commands))
      }
    },
    setDetailOnload (details, reservation) {
      return details && details.map(d => {
        // Make sure guest guestTypeId is not undefined
        if (!d.guestTypeId) d.guestTypeId = null
        if (!d.memberId) d.memberId = null
        if (!d.guestTypeId && !d.memberId) {
          // This must be a non discrete cover
          // Set it to TBD, if we can, just in case we have to display it as a discrete cover at some point
          d.guestTypeId = this.guestTbdId
        }
        // Set noShow if needed
        if (d.show === false) d.noShow = true
        return d
      })
    },
    withChildrenItemCommandFilter (command) {
      command.resultFilter = data => {
        data.details = this.setDetailOnload(data.details, data)
        data.cancelledDetails = this.setDetailOnload(data.cancelledDetails, data)
        if (data.id) this.showConfirmationDetails = true
        return data
      }
      const param = 'include_fields'
      this.addCommandParamArrayVal(command, param, 'cancelledDetails')
      this.addCommandParamArrayVal(command, param, 'calledBackBy')
      this.addCommandParamArrayVal(command, param, 'diningReservationDetail.notificationRcpts')
      this.addCommandParamArrayVal(command, param, 'diningReservationDetail.memberNumber')
      this.addCommandParamArrayVal(command, param, 'diningReservationDetail.cancelledBy')
      this.addCommandParamArrayVal(command, param, 'diningReservationDetail.username')
      this.addCommandParamArrayVal(command, param, 'diningReservationDetail.member')
      return command
    },
    afterLoad (item) {
      const itemData = this.itemData
      this.originalCalledAt = itemData.calledBackAt
      this.setDefaultNotificationMode(itemData)
      if (this.isNewItem) {
        if (this.selectedReservationType) {
          console.log('Selected Reservation Type', this.selectedReservationType)
          this.selectedReservationType.onSelect()
        }
        // Set one-click settings, if any
        if (this.eventId && !itemData.eventId) itemData.eventId = parseInt(this.eventId, 10)
        if (this.locationId && !itemData.locationId) itemData.locationId = parseInt(this.locationId, 10)
        if (this.sDate && !itemData.date) itemData.date = this.sDate
        if (this.sTime && !itemData.time) itemData.time = this.sTime
      }
    },
    guestTypesCommand () {
      return [
        {command: 'guestType', load: this.guestTypes, loading: this.isLoading, params: {filter_methods: {filterActivityId: [9999]}}},
      ]
    },
    beforeSaveItem (saveItemCallback) {
      // Set notification mode on save so we don't show the reservation as changed in the UI before save
      this.itemData.sendEmailMode = this.reservationNotificationMode
      saveItemCallback()
    },
    afterSave (r) {
      if (this.itemData.locationId && this.isPlaceholderReservation && this.selectedReservationType.code === 'WALK_IN') {
        // New WalkIn reservation saved -- store selected location for next time?
        localStorage.setItem('lastWalkInLocationId', this.itemData.locationId)
      }
    },
    itemResourceCommands () {
      return [
        {command: 'diningEvent', load: this.events, loading: this.isLoading, params: {include_fields: ['costs', 'locations']}}, // TODO:  Filter by available events (client side filter?)
        this.locationsCommand(),
        {command: 'diningReservationState', load: this.reservationStates, loading: this.isLoading},
        {command: 'diningOccasion', load: this.occasions, loading: this.isLoading},
        {command: 'diningCancellationReason', load: this.cancellationReasons, loading: this.isLoading},
        {command: 'diningConfirmationStatus', load: this.confirmationStatuses, loading: this.isLoading},
        {command: 'diningMealPeriod', load: this.allMealPeriods, loading: this.isLoading, params: {include_disabled: false}},
        {command: 'diningAvailableMealPeriodDates', load: this.availableMealPeriodDates, loading: this.isLoading},
        {command: 'diningBlocker', load: this.blockers, loading: this.isLoading, params: {include_disabled: false, include_fields: ['locations']}},
        {command: 'diningLocation', load: this.locations, loading: this.isLoading},
        {command: 'diningMusicalStyle', load: this.musicalStyles, loading: this.isLoading},
        {command: 'diningDressCode', load: this.dressCodes, loading: this.isLoading},
        {command: 'memberRestriction', load: this.memberRestrictions, loading: this.isLoading},
        ...this.guestTypesCommand(),
        {
          command: 'memberGroup',
          load: this.memberGroups,
          loading: this.isLoading,
          params: {filter: [{field: 'staticTypeId', operator: 'IS_NULL'}]}
        },
        {
          command: 'diningCancellationReason',
          load: this.cancellationReasons,
          loading: this.isLoading
        },
        {command: 'memberTypes', load: this.memberTypes, loading: this.isLoading}, // Legacy Api Command
        {command: 'membershipTypes', load: this.membershipTypes, loading: this.isLoading} // Legacy Api Command
      ]
    },
    eventsResourceCommand () {
      const filters = []
      if (this.minFilterDateTime) {
        filters.push({field: 'startDateTime', operator: 'GREATER_OR_EQUAL', values: [this.minFilterDateTime]})
      }
      if (this.maxFilterDateTime) {
        filters.push({field: 'startDateTime', operator: 'LESS_OR_EQUAL', values: [this.maxFilterDateTime]})
      }
      return {
        command: 'diningEvent',
        load: this.events,
        loading: this.isLoading,
        params: {
          include_fields: ['costs'],
          order_by: ['name:ASC', 'date:ASC'],
          filter: filters
        }
      }
    },
    beforeItemsLoad (data) {
      // If any items have issues, set value showing our list has issues
      this.itemsHaveIssue = !!data.find(i => i.issues)
    },
    listSearchFilter () {
      const filters = []
      if (!this.searchFilter.guestTypeId && this.searchFilter.memberId) {
        filters.push({
          field: 'id',
          operator: 'IN',
          subQueryTarget: 'diningReservationDetail.reservationId',
          subQueryFilter: [
            {field: 'memberId', operator: 'EQUAL', values: [this.searchFilter.memberId]},
            ...this.searchFilter.cancelled ? [] : [{field: 'cancelled', operator: 'IS_NULL'}]
          ]
        })
      }
      if (this.searchFilter.eventCostName) {
        const values = this.selectedEventsCostsFilter.reduce((acc, c) => {
          if (c.name === this.searchFilter.eventCostName) {
            acc.push(c.id)
          }
          return acc
        }, [])
        if (values.length) {
          const subQueryFilter = [
            {field: 'eventCostId', operator: 'IN', values: values},
            ...this.searchFilter.cancelled ? [] : [{field: 'cancelled', operator: 'IS_NULL'}]
          ]
          filters.push({
            field: 'id',
            operator: 'IN',
            subQueryTarget: 'diningReservationDetail.reservationId',
            subQueryFilter: subQueryFilter
          })
        }
      }
      if (this.searchFilter.guestTypeId) {
        const subQueryFilter = [
          {field: 'guestTypeId', operator: 'EQUAL', values: [this.searchFilter.guestTypeId]},
          ...this.searchFilter.cancelled ? [] : [{field: 'cancelled', operator: 'IS_NULL'}]
        ]
        if (!(this.guestTypeMap[this.searchFilter.guestTypeId] || {}).isTbd && this.searchFilter.guestSearch) {
          subQueryFilter.push({
            field: 'name',
            operator: 'LIKE',
            values: [this.searchFilter.guestSearch + '%']
          })
        }
        filters.push({
          field: 'id',
          operator: 'IN',
          subQueryTarget: 'diningReservationDetail.reservationId',
          subQueryFilter: subQueryFilter
        })
      }
      if (this.searchFilter.reservationNumber) {
        filters.push({field: 'id', operator: 'EQUAL', values: [this.searchFilter.reservationNumber]})
      }
      if (this.searchFilter.mealPeriodId) {
        filters.push({field: 'mealPeriodId', operator: 'EQUAL', values: [this.searchFilter.mealPeriodId]})
      }
      if (this.searchFilter.locationId) {
        filters.push({field: 'locationId', operator: 'EQUAL', values: [this.searchFilter.locationId]})
      }
      if (this.searchFilter.origByField) {
        filters.push({field: this.searchFilter.origByField, operator: 'IS_NOT_NULL'})
      }
      if (this.searchFilter.mealPeriodId) {
        filters.push({field: 'mealPeriodId', operator: 'EQUAL', values: [this.searchFilter.mealPeriodId]})
      }
      if (this.searchFilter.eventName) {
        filters.push({
          field: 'eventId',
          operator: 'IN',
          subQueryTarget: 'diningEvent.id',
          subQueryFilter: [
            {field: 'name', operator: 'EQUAL', values: [this.searchFilter.eventName]}
          ]
        })
      }
      if (this.searchFilter.date) {
        filters.push({
          field: 'dateTime',
          operator: 'BETWEEN',
          values: [
            this.searchFilter.date + ' 00:00:00',
            this.searchFilter.date + ' 23:59:59'
          ]
        })
      }
      if (this.searchFilter.confirmationStatusId) {
        filters.push({field: 'confirmationStatusId', operator: 'EQUAL', values: [this.searchFilter.confirmationStatusId]})
      }
      if (!this.searchFilter.cancelled) {
        filters.push({field: 'cancelled', operator: 'IS_NULL'})
      }
      const selectedDays = daysLower.map((d, i) => {
        return {dayName: d, day: i + 1}
      }).filter(d => this.searchFilter.days[d.dayName]).map(d => d.day)
      if (selectedDays.length) {
        filters.push({field: 'dayOfWeek', operator: 'IN', values: selectedDays})
      }
      if (this.showWaitlist !== null) {
        filters.push({field: 'waitlist', operator: 'EQUAL', values: [!!this.showWaitlist]})
      }
      return filters
    },
    locationsCommand () {
      return {
        command: 'diningLocation',
        load (locations) {
          const selectedLocation = locations.find(l => l.id === this.selectedLocationId)
          if (this.isNewItem && selectedLocation && selectedLocation.disabled) {
            this.itemData.locationId = null // Deselect selected location if new and prev. location was disabled.
          }
          this.locations = locations
        },
        loading: this.isLoading
      }
    },
    tableNumberUsageCommand () {
      const filters = []
      filters.push({field: 'cancelled', operator: 'IS_NULL'})
      if (this.itemData.id) {
        filters.push({field: 'id', operator: 'NOT_EQUAL', values: [this.itemData.id]})
      }
      if (this.selectedEventId) {
        filters.push({field: 'eventId', operator: 'EQUAL', values: [this.selectedEventId]})
      } else {
        filters.push({field: 'eventId', operator: 'IS_NULL'})
        if (this.selectedDate) {
          filters.push({field: 'date', operator: 'EQUAL', values: [this.selectedDate]})
        }
      }
      if (this.selectedLocationId) {
        filters.push({field: 'locationId', operator: 'EQUAL', values: [this.selectedLocationId]})
      }
      const selectedSeatingTime = this.selectedSeatingTime
      if (selectedSeatingTime) {
        if (selectedSeatingTime.mealPeriodId) {
          filters.push({field: 'mealPeriodId', operator: 'EQUAL', values: [selectedSeatingTime.mealPeriodId]})
        }
        if (!this.noTimeSelected) {
          const seatingDateTime = moment(selectedSeatingTime.date + ' ' + selectedSeatingTime.time)
          const dateTimeStart = seatingDateTime.clone().subtract(this.tableNumberUseOffset, 'minute').format('YYYY-MM-DD HH:mm:ss')
          const dateTimeEnd = seatingDateTime.clone().add(this.tableNumberUseOffset, 'minute').format('YYYY-MM-DD HH:mm:ss')
          filters.push({field: 'dateTime', operator: 'BETWEEN', values: [dateTimeStart, dateTimeEnd]})
        }
      }
      return {
        command: 'diningReservation',
        load: this.tableNumberUsage,
        loading: this.isLoading,
        params: {
          filter: filters,
          group_by: ['date:ASC', 'locationName:ASC', 'time:ASC'],
          order_by: ['time:ASC'],
          only_fields: ['date', 'locationName', 'time', 'tableNumbers']
        }
      }
    },
    eventToLocationsCommand () {
      return {
        command: 'diningEventToLocation',
        load: this.eventToLocations,
        loading: this.isLoading,
        params: {
          filter: [
            {field: 'eventId', operator: 'EQUAL', values: [this.selectedEventId]},
            {field: 'isBlocker', operator: 'EQUAL', values: [false]}
          ]
        }
      }
    },
    mealPeriodsCommand () {
      const command = {
        command: 'diningMealPeriod',
        load: this.mealPeriods,
        loading: this.isLoading,
        params: {target_date: this.selectedDate}
      }
      return command
    },
    tableConfigurationsCommand () {
      const command = {
        command: 'diningTableConfiguration',
        load: this.tableConfigurations,
        loading: this.isLoading,
        params: {
          filter_methods: {filterFieldValue: ['locationId', this.selectedLocationId]},
          children: true,
          include_disabled: true,
        }
      }
      if (this.selectedLocationId) {
        return [command]
      } else {
        this.tableConfigurations = []
        return []
      }
    },
    eventAndSeatingTimesCommand () {
      const params = {
        children: true,
        filter: [{field: 'id', operator: 'EQUAL', values: [this.selectedEventId]}],
        include_fields: ['fullSeatings']
      }
      if (this.itemData && this.itemData.id) {
        params.exclude_reservation_id = this.itemData.id
      }
      const command = {
        command: 'diningEvent',
        load: (event) => {
          console.log('Loaded event:', event)
          if (event && event[0]) {
            this.event = event[0]
            this.eventToLocations = this.event.locations.filter(l => !l.isBlocker)
            this.seatingTimes = this.event.fullSeatings
            console.log('Loaded seatingTimes:', this.event.fullSeatings)
          }
        },
        // load: this.seatingTimes,
        loading: this.isLoading,
        params: params
      }
      if (this.itemData.locationId) {
        // this.addCommandParamArrayVal(command, 'filter', { field: 'diningEventToLocation.locationId', operator: 'EQUAL', values: [this.itemData.locationId] })
      }
      return command
    },
    mealPeriodSeatingTimesCommand () {
      const params = {target_date: this.selectedDate}
      if (this.itemData && this.itemData.id) {
        params.exclude_reservation_id = this.itemData.id
      }
      const command = {
        command: 'diningMealPeriodSeating',
        load: this.seatingTimes,
        loading: this.isLoading,
        params: params
      }
      if (this.itemData.locationId) {
        this.addCommandParamArrayVal(command, 'filter', {field: 'diningMealPeriod.locationId', operator: 'EQUAL', values: [this.itemData.locationId]})
      }
      return command
    },
    seatingTimesCommands () {
      if (this.forEvent) {
        return [this.locationsCommand(), this.eventToLocationsCommand(), ...this.tableConfigurationsCommand(), this.eventAndSeatingTimesCommand()]
      } else {
        return [this.locationsCommand(), this.mealPeriodsCommand(), ...this.tableConfigurationsCommand(), this.mealPeriodSeatingTimesCommand()]
      }
    },
    loadSeatingTimes () {
      if (!this.selectedDate) {
        // Can't get seating times without a date
        this.seatingTimes = []
        return
      }
      // Re-load locations and meal periods to make sure they are up-to-date
      this.$ftAPI().get(this.addResourceErrorHandler(this.seatingTimesCommands()))
    },
    loadLocationTables () {
      // Re-load location tables
      this.$ftAPI().get(this.addResourceErrorHandler([...this.tableConfigurationsCommand()]))
    },
    loadTableNumberUsage () {
      this.tableNumberUsage = [] // clear before loading so we don't show the wrong table numbers
      this.$ftAPI().get(this.addResourceErrorHandler(this.tableNumberUsageCommand()))
    }
  }
}
